/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventViewModel
 */
export interface EventViewModel {
    /**
     * 
     * @type {string}
     * @memberof EventViewModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventViewModel
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof EventViewModel
     */
    subtext?: string;
    /**
     * 
     * @type {Date}
     * @memberof EventViewModel
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof EventViewModel
     */
    type: string;
}

/**
 * Check if a given object implements the EventViewModel interface.
 */
export function instanceOfEventViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function EventViewModelFromJSON(json: any): EventViewModel {
    return EventViewModelFromJSONTyped(json, false);
}

export function EventViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'title': json['Title'],
        'subtext': !exists(json, 'Subtext') ? undefined : json['Subtext'],
        'date': (new Date(json['Date'])),
        'type': json['Type'],
    };
}

export function EventViewModelToJSON(value?: EventViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Title': value.title,
        'Subtext': value.subtext,
        'Date': (value.date.toISOString()),
        'Type': value.type,
    };
}

